// src/app/services/wake-lock.service.ts
import { Injectable, OnDestroy } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WakeLockService implements OnDestroy {
  private wakeLock: WakeLockSentinel | null = null;

  private wakeDesired: boolean = false;

  private isWakeLockActive = (): boolean => this.wakeLock !== null;

  constructor() {
    // Attach event listener that will automatically re-request the lock in case the screen is turned off, then back on
    document.addEventListener("visibilitychange", this.onVisibilityChange);
  }

  /**
   * This handler will be triggered whenever the page's visibility is changed
   * <br>
   * It checks if the document is 'visible' + if the lock is no longer active + it should be
   * <br>
   * If the three conditions are met, it will request a new WakeLock
   */
  private onVisibilityChange = async () => {
    if ((document.visibilityState === "visible" && !this.isWakeLockActive()) || this.wakeDesired) {
      await this.requestWakeLock();
    }
  };

  /**
   * Request a WakeLock from the navigator object, if supported
   * <br>
   * An active WakeLock will prevent mobile devices' screens from dimming or turning off
   */
  async requestWakeLock() {
    if ('wakeLock' in navigator) {
      try {
        this.wakeDesired = true;
        this.wakeLock = await (navigator as any).wakeLock.request('screen');
        if(this.wakeLock){
          this.wakeLock.addEventListener("release", () => console.log('Wake Lock was released'));
          console.log('Wake Lock is active');
        }
      } catch (err: any) {
        console.error(`${err.name}, ${err.message}`);
      }
    } else {
      console.warn('Wake Lock API not supported on this device');
    }
  }

  /**
   * Releases the WakeLock, if present
   */
  async releaseWakeLock() {
    if (this.wakeLock) {
      this.wakeDesired = false;
      await this.wakeLock.release();
      this.wakeLock = null;
      console.log('Wake Lock has been released');
    }
  }

  async ngOnDestroy() {
    // Release lock and detach the event handler
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
    await this.releaseWakeLock();
  }
}
